import type { FlexProps } from '@chakra-ui/react';
import { Box, Checkbox, Flex, Image } from '@chakra-ui/react';
import type { NftCollection } from '@ui/queries/types';
import { useIsNftCollectionEnded } from '@ui/queries/types';
import type { PropsWithChildren } from 'react';
import React from 'react';

import GardenNftCountdown from '../GardenStakeNftDrawer/GardenNftCountdown';

type StakeCruiserCardProps = {
  multiplier: number | undefined;
  name: string;
  tokenId: string;
  imageUrl: string;
  active: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  checkable?: boolean;
  collection: NftCollection;
} & FlexProps;

function StakeCruiserCard({
  multiplier,
  active,
  name,
  tokenId,
  imageUrl,
  onClick,
  disabled,
  checkable,
  children,
  collection,
  ...flexProps
}: PropsWithChildren<StakeCruiserCardProps>) {
  const isEnded = useIsNftCollectionEnded(collection);

  return (
    <Box display="contents">
      <Flex
        onClick={!disabled ? onClick : (e) => e.stopPropagation()}
        position="relative"
        flexDir="column"
        align="center"
        gap={2}
        shadow={active ? 'card.active' : disabled ? undefined : 'card.normal'}
        cursor={onClick && !disabled ? 'pointer' : 'default'}
        opacity={disabled ? 0.5 : undefined}
        {...flexProps}
      >
        <GardenNftCountdown
          collection={collection}
          mt={0}
          zIndex={1}
          mb={-4}
          maxW="98px"
          small
        />
        <Box w="84px" h="84px" opacity={isEnded ? 0.5 : 1} position="relative">
          <Image rounded="4px" w="full" h="full" src={imageUrl} alt={name} />
          <Box top={0} left={0} position="absolute" w="full" h="full">
            {children}
          </Box>
        </Box>
        <Box textStyle="ctaCopy" opacity={isEnded ? 0.5 : 1}>
          #{tokenId}
        </Box>
        {!isEnded && (
          <Box
            w="84px"
            bg="linear-gradient(90deg, #6666ff, #ff66ad)"
            p="1px"
            rounded="2px"
          >
            <Box
              textAlign="center"
              textStyle="ctaCopy"
              color="white"
              rounded="2px"
              p="3px 4px 5px 4px"
              bgColor="brand.black"
            >
              {multiplier ? '+' + multiplier.toFixed(3) + 'x' : '--x'}
            </Box>
          </Box>
        )}
        {checkable !== false && (
          <Checkbox
            colorScheme="pink"
            variant="pink"
            pointerEvents="none"
            isChecked={active}
            position="absolute"
            top={3}
            right={3}
          />
        )}
      </Flex>
    </Box>
  );
}

export default StakeCruiserCard;
